exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section[data-v-1e0f1e83] {\n  position: relative;\n}\n.highlight-section[data-v-1e0f1e83] {\n  color: #fff;\n}\n.btn-bar .subtitle[data-v-1e0f1e83] {\n  font-size: 12px;\n  margin-top: 6px !important;\n  opacity: .75;\n}\n", ""]);

// exports
